import { render, staticRenderFns } from "./PlayerAlliedParty.vue?vue&type=template&id=185c284e"
import script from "./PlayerAlliedParty.vue?vue&type=script&lang=ts"
export * from "./PlayerAlliedParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports